/**
 * The below file contains the action methods for fire cause master.
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import {
  GET_ALL_FLOOD_DEATH_CAUSE,
  SET_ALL_FLOOD_DEATH_CAUSE,
} from "redux/constants/FloodDeathCause";

//#region Action methods for fetching fire causes

/**
 * Method for getting the fire causes
 * @param {any} params Fire Data
 * @returns Json Object
 */
export const getAllFloodDeathCause = () => {
  return {
    type: GET_ALL_FLOOD_DEATH_CAUSE,
  };
};

/**
 * Method for setting the fire causes
 * @param {any} params Fire Data
 * @returns Json Object
 */
export const setAllFloodDeathCause = (data) => {
  return {
    type: SET_ALL_FLOOD_DEATH_CAUSE,
    payload: data,
  };
};

//#endregion